// extracted by mini-css-extract-plugin
export default {"productGallery":"XF-z","inQuickShop":"YF-z"};